import {
  FetchPathSettingsRequest,
  FetchPathSettingsSuccess,
  FetchPathSettingsFailure,
  UpdatePathSettingsRequest,
  UpdatePathSettingsSuccess,
  UpdatePathSettingsFailure,
} from './path-settings.actions'
import { PathSettingsService } from './path-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SmtpSettingsTypes from './path-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class PathSettingsEffects {
  constructor(
    private actions: Actions,
    private pathSettingsService: PathSettingsService,
  ) {}

  FetchPathSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SmtpSettingsTypes.FETCH_PATH_SETTINGS_REQUEST),
      switchMap((action: FetchPathSettingsRequest) => {
        return this.pathSettingsService.fetchPathSettings().pipe(
          map((result) => {
            return new FetchPathSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchPathSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdatePathSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SmtpSettingsTypes.UPDATE_PATH_SETTINGS_REQUEST),
      switchMap((action: UpdatePathSettingsRequest) => {
        return this.pathSettingsService.updatePathSettings(action.payload).pipe(
          switchMap((result) => {
            return [new UpdatePathSettingsSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdatePathSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
